"use client";
import React from "react";
import {LazyLoadComponent, LazyLoadComponentProps} from "react-lazy-load-image-component";

export const LazyComp: React.FC<LazyLoadComponentProps> = ({visibleByDefault, ...props}) => (
  <LazyLoadComponent {...props} visibleByDefault={visibleByDefault} />
);
